import { render, staticRenderFns } from "./GitlabIssue.vue?vue&type=template&id=eb0ffee8&scoped=true"
import script from "./GitlabIssue.vue?vue&type=script&lang=ts"
export * from "./GitlabIssue.vue?vue&type=script&lang=ts"
import style0 from "./GitlabIssue.vue?vue&type=style&index=0&id=eb0ffee8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0ffee8",
  null
  
)

export default component.exports